import { useState, useCallback } from "react";
import { BsBox2Fill } from "react-icons/bs";
import { InputField, RadioInput, DateInput } from "@/components";
import { useFieldError } from "@/";

const OrderDetails = ({
  data,
  setData,
  errors = [],
  isDisabled = false,
  showShipment = false,
}) => {
  const getErrorMessage = useFieldError(errors);
  const handleChange = useCallback((field, value) => {
    setData((prev) => ({ ...prev, [field]: value }));
  }, []);

  const handleInvoiceChange = useCallback((field, value) => {
    setData((prev) => ({
      ...prev,
      invoice: { ...prev.invoice, [field]: value },
    }));
  }, []);

  const handleEBNChange = useCallback((field, value) => {
    setData((prev) => ({
      ...prev,
      ebn: {
        ...prev.ebn,
        [field]: value,
      },
    }));
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  return (
    <div className="w-full h-full flex flex-col gap-2 border-2 border-secondary/30 rounded-2xl p-4">
      <div className="flex gap-2 items-center">
        <BsBox2Fill className="text-headline4 text-secondary/80" />
        <h2 className="text-headline4 text-secondary/80 font-nunito font-semibold">
          Order Details
        </h2>
      </div>

      <form onSubmit={handleSubmit} className="flex flex-col gap-2">
        {/* Order ID & Order Date */}
        <div className="flex flex-col  gap-2">
          <InputField
            type="text"
            label="Order ID"
            placeholder="Enter the Order ID"
            value={data.orderId}
            onChange={(value) => handleChange("orderId", value)}
            error={getErrorMessage("orderId")}
            disabled={isDisabled}
          />
          <DateInput
            label="Order Date"
            placeholder="Select Order Date"
            value={data.orderDate}
            onChange={(value) => handleChange("orderDate", value)}
            error={getErrorMessage("orderDate")}
            disabled={isDisabled}
          />
        </div>

        {/* Invoice No & Invoice Date */}
        <div className="flex flex-col gap-2">
          <InputField
            type="text"
            label="Invoice Number"
            placeholder="Enter the Invoice Number"
            value={data.invoice.invoiceNumber}
            onChange={(value) => handleInvoiceChange("invoiceNumber", value)}
            error={getErrorMessage("invoice.invoiceNumber")}
            disabled={isDisabled}
          />
          <DateInput
            label="Invoice Date"
            placeholder="Select Invoice Date"
            value={data.invoice.invoiceDate}
            onChange={(value) => handleInvoiceChange("invoiceDate", value)}
            error={getErrorMessage("invoice.invoiceDate")}
            disabled={isDisabled}
          />
        </div>

        {/* Payment Mode */}
        <RadioInput
          label="Payment Mode"
          options={[
            { value: "Prepaid", label: "Prepaid" },
            { value: "COD", label: "Cash on Delivery" },
          ]}
          name="paymentMode"
          selectedValue={data.paymentMode}
          onChange={(value) => handleChange("paymentMode", value)}
          error={getErrorMessage("paymentMode")}
          disabled={isDisabled}
        />

        {/* EBN No. & EBN Expiry Date */}
        <div className="flex flex-col gap-2">
          <InputField
            type="text"
            label="EBN Number"
            placeholder="Enter the EBN Number"
            value={data.ebn.ebnNumber || ""}
            onChange={(value) => handleEBNChange("ebnNumber", value)}
            error={getErrorMessage("ebn.ebnNumber")}
            disabled={isDisabled}
          />
          <DateInput
            label="EBN Expiry Date"
            placeholder="Select Expiry Date"
            value={
              data.ebn.ebnExpiryDate === null
                ? ""
                : data.ebn.ebnExpiryDate || ""
            }
            onChange={(value) => handleEBNChange("ebnExpiryDate", value)}
            error={getErrorMessage("ebn.ebnExpiryDate")}
            disabled={isDisabled}
          />
        </div>

        {showShipment && (
          <div className="flex flex-col  gap-2">
            <InputField
              type="text"
              label="Shipping ID"
              placeholder="Enter shipment id"
              value={data.shipmentId}
              onChange={(value) => handleChange("shipmentId", value)}
              error={getErrorMessage("shipmentId")}
              disabled={isDisabled}
            />
          </div>
        )}
        {getErrorMessage("ebn") && (
          <span className="text-red-500 text-sm">{getErrorMessage("ebn")}</span>
        )}
      </form>
    </div>
  );
};

export default OrderDetails;
